export const Colors = {
  GREEN_25: 'var(--color-green-25)',
  GREEN_50: 'var(--color-green-50)',
  GREEN_100: 'var(--color-green-100)',
  GREEN_200: 'var(--color-green-200)',
  GREEN_300: 'var(--color-green-300)',
  GREEN_400: 'var(--color-green-400)',
  GREEN_500: 'var(--color-green-500)',
  GREEN_600: 'var(--color-green-600)',
  GREEN_700: 'var(--color-green-700)',
  GREEN_800: 'var(--color-green-800)',
  GREEN_900: 'var(--color-green-900)',
  GREEN_950: 'var(--color-green-950)',
  GREEN_975: 'var(--color-green-975)',

  PURPLE_25: 'var(--color-purple-25)',
  PURPLE_50: 'var(--color-purple-50)',
  PURPLE_100: 'var(--color-purple-100)',
  PURPLE_200: 'var(--color-purple-200)',
  PURPLE_300: 'var(--color-purple-300)',
  PURPLE_400: 'var(--color-purple-400)',
  PURPLE_500: 'var(--color-purple-500)',
  PURPLE_600: 'var(--color-purple-600)',
  PURPLE_700: 'var(--color-purple-700)',
  PURPLE_800: 'var(--color-purple-800)',
  PURPLE_900: 'var(--color-purple-900)',
  PURPLE_950: 'var(--color-purple-950)',
  PURPLE_975: 'var(--color-purple-975)',

  RED_25: 'var(--color-red-25)',
  RED_50: 'var(--color-red-50)',
  RED_100: 'var(--color-red-100)',
  RED_200: 'var(--color-red-200)',
  RED_300: 'var(--color-red-300)',
  RED_400: 'var(--color-red-400)',
  RED_500: 'var(--color-red-500)',
  RED_600: 'var(--color-red-600)',
  RED_700: 'var(--color-red-700)',
  RED_800: 'var(--color-red-800)',
  RED_900: 'var(--color-red-900)',
  RED_950: 'var(--color-red-950)',
  RED_975: 'var(--color-red-975)',

  AMBER_25: 'var(--color-amber-25)',
  AMBER_50: 'var(--color-amber-50)',
  AMBER_100: 'var(--color-amber-100)',
  AMBER_200: 'var(--color-amber-200)',
  AMBER_300: 'var(--color-amber-300)',
  AMBER_400: 'var(--color-amber-400)',
  AMBER_500: 'var(--color-amber-500)',
  AMBER_600: 'var(--color-amber-600)',
  AMBER_700: 'var(--color-amber-700)',
  AMBER_800: 'var(--color-amber-800)',
  AMBER_900: 'var(--color-amber-900)',
  AMBER_950: 'var(--color-amber-950)',
  AMBER_975: 'var(--color-amber-975)',

  BLUE_25: 'var(--color-blue-25)',
  BLUE_50: 'var(--color-blue-50)',
  BLUE_100: 'var(--color-blue-100)',
  BLUE_200: 'var(--color-blue-200)',
  BLUE_300: 'var(--color-blue-300)',
  BLUE_400: 'var(--color-blue-400)',
  BLUE_500: 'var(--color-blue-500)',
  BLUE_600: 'var(--color-blue-600)',
  BLUE_700: 'var(--color-blue-700)',
  BLUE_800: 'var(--color-blue-800)',
  BLUE_900: 'var(--color-blue-900)',
  BLUE_950: 'var(--color-blue-950)',
  BLUE_975: 'var(--color-blue-975)',

  NEUTRAL_25: 'var(--color-neutral-25)',
  NEUTRAL_30: 'var(--color-neutral-30)',
  NEUTRAL_50: 'var(--color-neutral-50)',
  NEUTRAL_100: 'var(--color-neutral-100)',
  NEUTRAL_200: 'var(--color-neutral-200)',
  NEUTRAL_300: 'var(--color-neutral-300)',
  NEUTRAL_400: 'var(--color-neutral-400)',
  NEUTRAL_500: 'var(--color-neutral-500)',
  NEUTRAL_600: 'var(--color-neutral-600)',
  NEUTRAL_700: 'var(--color-neutral-700)',
  NEUTRAL_800: 'var(--color-neutral-800)',
  NEUTRAL_900: 'var(--color-neutral-900)',
  NEUTRAL_950: 'var(--color-neutral-950)',
  NEUTRAL_975: 'var(--color-neutral-975)',

  GREEN_HIGHLIGHT: 'var(--color-green-highlight)',

  WHITE: 'var(--color-white)',
  BLACK: 'var(--color-black)',

  VAURAUS_DARK_PURPLE: 'var(--color-vauraus-dark-purple)',
  VAURAUS_LIGHT_PURPLE: 'var(--color-vauraus-light-purple)',

  BACKGROUND_DEFAULT: 'var(--theme-color-background-default)',
  BACKGROUND_SUBTLE: 'var(--theme-color-background-subtle)',
  BACKGROUND_OVERLAY: 'var(--theme-color-background-overlay)',

  SURFACE_DEFAULT: 'var(--theme-color-surface-default)',
  SURFACE_SUBTLE: 'var(--theme-color-surface-subtle)',
  SURFACE_DISABLED: 'var(--theme-color-surface-disabled)',
  SURFACE_ACTION_PRIMARY: 'var(--theme-color-surface-action-primary)',
  SURFACE_ACTION_SECONDARY: 'var(--theme-color-surface-action-secondary)',
  SURFACE_ACTION_TERTIARY: 'var(--theme-color-surface-action-tertiary)',
  SURFACE_ICON_HIGHLIGHT: 'var(--theme-color-surface-icon-highlight)',
  SURFACE_SUCCESS: 'var(--theme-color-surface-success)',
  SURFACE_ERROR: 'var(--theme-color-surface-error)',
  SURFACE_WARNING: 'var(--theme-color-surface-warning)',
  SURFACE_INFO: 'var(--theme-color-surface-info)',
  SURFACE_PROMO: 'var(--theme-color-surface-promo)',
  SURFACE_PROMO_SUBTLE: 'var(--theme-color-surface-promo-subtle)',

  TEXT_DEFAULT: 'var(--theme-color-text-default)',
  TEXT_SUBTLE: 'var(--theme-color-text-subtle)',
  TEXT_HIGHLIGHT: 'var(--theme-color-text-highlight)',
  TEXT_INVERSE: 'var(--theme-color-text-inverse)',
  TEXT_SUCCESS: 'var(--theme-color-text-success)',
  TEXT_DISABLED: 'var(--theme-color-text-disabled)',
  TEXT_PROMO: 'var(--theme-color-text-promo)',
  TEXT_BRAND: 'var(--theme-color-text-brand)',
  TEXT_ERROR: 'var(--theme-color-text-error)',
  TEXT_WARNING: 'var(--theme-color-text-warning)',

  ICON_DEFAULT: 'var(--theme-color-icon-default)',
  ICON_SUBTLE: 'var(--theme-color-icon-subtle)',
  ICON_INVERSE: 'var(--theme-color-icon-inverse)',
  ICON_HIGHLIGHT: 'var(--theme-color-icon-highlight)',
  ICON_SUCCESS: 'var(--theme-color-icon-success)',
  ICON_ERROR: 'var(--theme-color-icon-error)',
  ICON_WARNING: 'var(--theme-color-icon-warning)',
  ICON_INFO: 'var(--theme-color-icon-info)',
  ICON_DISABLED: 'var(--theme-color-icon-disabled)',
  ICON_BRAND: 'var(--theme-color-icon-brand)',

  BORDER_DEFAULT: 'var(--theme-color-border-default)',
  BORDER_HIGHLIGHT: 'var(--theme-color-border-highlight)',
  BORDER_SUCCESS: 'var(--theme-color-border-success)',
  BORDER_ERROR: 'var(--theme-color-border-error)',
  BORDER_WARNING: 'var(--theme-color-border-warning)',
  BORDER_DISABLED: 'var(--theme-color-border-disabled)',
  BORDER_DARK: 'var(--theme-color-border-dark)',
  BORDER_BRAND: 'var(--theme-color-border-brand)',

  DIVIDER_DEFAULT: 'var(--theme-color-divider-default)',
} as const;
